const helperModals = function (app) {
    const $document = $(document);
    const dataAttr = "data-js-open-modal";
    const selector = `[${dataAttr}]`;

    const init = function () {
        // don't risk registering events more than once a page
        if (!app.modalsReady) {
            app.modalsReady = true;
            registerEvents();
        }
    };

    const registerEvents = function () {
        $document.on("click", selector, function (ev) {
            ev.preventDefault();
            const $elt = $(ev.target).closest(selector);
            const params = $elt.attr("data-js-open-modal-params");
            window.dispatchEvent(
                new CustomEvent(
                    $elt.attr(dataAttr),
                    params
                        ? { detail: { ...JSON.parse(params), source: $elt[0] } }
                        : undefined,
                ),
            );
        });
    };

    return {
        init: init(),
    };
};

export default helperModals;
